import React, { useContext, useRef } from 'react';
import styled from 'styled-components';
import SortByContainer from '../search-filters/sort-by-input/SortByContainer';
import SliderContainer from '../search-filters/slider-view/SliderContainer';
import { SearchFiltersTypes } from '../../../../reducers/search-filters/reducer';
import useSearchResults from '../../../../hooks/SearchResults';
import {
  SearchContext,
  SearchContextInterface
} from '../../../search-new/context/SearchContext';
interface FilterBarProps {
  loadedSearchResultsSSR: any;
}
const FilterBar = ({ loadedSearchResultsSSR }: FilterBarProps) => {
  const { filterOptions, searchFiltersState, searchFiltersDispatch } =
    useContext(SearchContext) as SearchContextInterface;
  const filtersRef = useRef<HTMLDivElement>(null);
  const searchBodyResults = useSearchResults(
    searchFiltersState.searchBody,
    loadedSearchResultsSSR
  );
  return (
    <BarContainer>
      <div className="filter-bar container-fluid">
        <FilterMenu>
          <div
            className={
              searchFiltersState.searchFilters.category === 'property'
                ? 'filters property-filters'
                : 'filters'
            }
            ref={filtersRef}
          >
            <SliderContainer
              searchFiltersState={searchFiltersState}
              searchFiltersDispatch={searchFiltersDispatch}
              filterName={SearchFiltersTypes.PROPERTY_TYPES}
              filterTypes={filterOptions[SearchFiltersTypes.PROPERTY_TYPES]}
              options={searchBodyResults.loadedPropertyTypes}
              withCountDisplay={true}
              sliderLocation="TopOfTheGrid"
            />
          </div>
          <div className="search-actions">
            <SortByContainer
              sortByOptions={filterOptions[SearchFiltersTypes.SORT_BY]}
              searchFiltersState={searchFiltersState}
              searchFiltersDispatch={searchFiltersDispatch}
              sortLocation="TopOfTheGrid"
            />
          </div>
        </FilterMenu>
      </div>
    </BarContainer>
  );
};

const BarContainer = styled.div`
  background-color: ${props => props.theme.light.backgroundColor};
  height: 100px;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  position: sticky;
  top: 70px;
  transition: all 0.6s ease-out;
  box-shadow: 0px 4px 16px 0px #0000000d;

  .filter-bar {
    display: flex;
    flex-direction: row;
    gap: 6px;
    transition: all 0.6s ease-out;
    height: 100%;
  }
`;

const FilterMenu = styled.div`
  height: 100%;
  background-color: ${props => props.theme.light.colors.white};
  border-radius: ${props => props.theme.borderRadius};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  button {
    outline: none;
    border: none;
  }

  .search-actions {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    width: fit-content;
    height: 100%;

    button {
      font-family: materialMedium;
      border: 1px solid #e4ebf2;
      border-radius: 8px;
    }
  }

  .filters {
    width: calc(100% - 180px);

    &.property-filters {
      width: calc(100% - 300px);
    }
  }
`;

export default FilterBar;
